module.exports = __webpack_public_path__ + "img/Icone_100.894967b9.svg";